//Allow users to track daily calorie intake and generate reports
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CalorieTracker = () => {
  const [calories, setCalories] = useState([]);
  const [totalCalories, setTotalCalories] = useState(0);

  useEffect(() => {
    const fetchCalories = async () => {
      const response = await axios.get('/api/calories');
      setCalories(response.data);
      const total = response.data.reduce((acc, item) => acc + item.amount, 0);
      setTotalCalories(total);
    };
    fetchCalories();
  }, []);

  return (
    <div>
      <h2>Total Calories: {totalCalories}</h2>
      <ul>
        {calories.map((calorie) => (
          <li key={calorie._id}>{calorie.date}: {calorie.amount} kcal</li>
        ))}
      </ul>
    </div>
  );
};

export default CalorieTracker;
